export enum AMLStatusEnum {
  PENDING_REVIEW = 'pending_review',
  SUCCEED = 'succeed',
  PENDING = 'pending',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
}
